import { useState } from "react";
import DynamicIcon from "./dynamic_icon";

interface Props {
  children: JSX.Element
  title: string
  defaultOpen?: boolean
  fontWeight?: 'normal' | 'bold'
  textColor?: string
  titleBackgroundColor?: string
}

function CascateList({ title, defaultOpen = false, children, fontWeight, textColor = 'text-black dark:text-white', titleBackgroundColor = 'bg-light-mode-2 dark:bg-dark-mode-2' }: Props) {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  return (
    <div className="w-full flex flex-col bg-light-mode-2 dark:bg-dark-mode-2 rounded-[4px] border-[1px] border-border-light-gray dark:border-border-dark-gray">
      <div className={`w-full h-14 flex justify-between items-center px-6 cursor-pointer hover:bg-hover-light-mode dark:hover:bg-hover-dark-mode ${titleBackgroundColor}`}
        onClick={() => setIsOpen(!isOpen)}
      >
        <h1 className={`${textColor === 'orange' ? 'text-orange-500' : textColor} ${fontWeight === 'bold' ? 'font-bold' : 'font-normal'}`}>{title}</h1>
        <DynamicIcon nameIcon={isOpen ? "KeyboardArrowDownRounded" : "KeyboardArrowUpRounded"} size={25} className="text-black dark:text-white" />
      </div>
      {
        isOpen === true &&
        <div className="w-full flex justify-between items-center p-6 border-t-[1px] border-border-light-gray dark:border-border-dark-gray">
          {children}
        </div>
      }

    </div >
  );
}

export default CascateList;